import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="container-fluid problems">
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="row">
            <div
              className="col-md-6 col-sm-12 mx-auto newdetails para"
              data-aos="zoom-in"
            >
              <img
                src={require("../images/error1.svg")}
                alt="error"
                className="errimg"
              />

              <h4>Ohh Dear!! Looks like you got lost</h4>
              <p>let's go back Home, shall we ?</p>

              <Link to="/">
                <button className="cbtn">Home</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
